import HeadingGroup from './HeadingGroup';

// export types
export type { HeadingGroupProps } from './HeadingGroup';

// export components
export { HeadingGroup };
export default HeadingGroup;
